<template>
    <div class="label-manage-page layout-sub-page">
        <!-- 1. 顶部标题栏 -->
        <title-bar 
            v-if="!fromEmbedded || (fromEmbedded && !hideTitle)"
            v-bind:titleData="titleData"
            v-bind:backFunc="clickBack">
        </title-bar>

        <!-- 2. 标签列表部分 -->
        <div class="label-manage-content" v-bind:class="{'label-manage-content-embedded': (fromEmbedded && hideTitle)}">
            <div class="label-manage-title">*点击需要编辑的标签即可管理</div>
            <div class="label-list">
                <span v-for="label in myLabelData" v-bind:key="label.id" class="label-item" @click="clickLabelItem(label)">{{label.f_title}}</span>
            </div>
        </div>

        <!-- 3. 修改标签弹框 -->
        <van-dialog v-model="showEditLabelPop" title="修改标签" confirmButtonText='确定' cancelButtonText='删除' v-bind:before-close="beforeClose" show-cancel-button>
            <div class="create-group-input">
                <input type="text" v-model="inputValue" @blur="blurInput" placeholder="输入标签" maxlength="12" autofocus >
            </div>
        </van-dialog>
    </div>
</template>
<script>
import TitleBar from '../../components/TitleBar.vue'
export default {
    name: 'LabelManage',
    components: {TitleBar},
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        hideTitle() {
            return this.$store.state.embedded.hideTitle;
        },
        myLabelData() {
            return this.$store.state.label.myLabelData;
        },
    },
    data() {
        return {
            inputValue: '',
            showEditLabelPop: false,
            curEditLabelData: {},
            titleData: {'titleText': '自定义标签管理', 'showCancel': false},
        }
    },
    mounted: function() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.width = window.innerWidth + 'px';
            this.$el.style.height = window.innerHeight + 'px';
        },
        clickBack() {
            var curPath = this.$router.history.current.path,
                curUrl = window.location.href;
            if(curPath.indexOf('embedded') == -1) {
                curPath = curPath.replace('labelmanage', 'label');
                this.$router.replace(curPath);
            }else {
                curUrl = curUrl.replace('labelmanage', 'label');
                window.location = curUrl;
            }
        },
        clickLabelItem(data) {
            this.showEditLabelPop = true;
            this.curEditLabelData = data;
            this.inputValue = data.f_title;
        },
        blurInput() {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 20);
        },
        beforeClose(action, done) {
            var me = this;
            if (action === 'confirm') {
                if(this.inputValue != ''){
                    if(this.inputValue == this.curEditLabelData.f_title) {
                        done();
                        return;
                    }
                    console.log('请求修改标签', this.inputValue, this.curEditLabelData)
                    this.$store.dispatch('label/updateLabel', {
                        id: this.curEditLabelData.id,
                        newTitle: this.inputValue,
                        cb: function() {
                            me.$toast('修改标签成功');
                            me.updateEditPageLabel();
                        }
                    })
                    done();
                }else {
                    this.$toast("标签不能为空");
                    done();
                }
            } else {
                console.log('请求删除标签', this.curEditLabelData)
                this.$store.dispatch('label/deleteLabel',  {
                    id: this.curEditLabelData.id,
                    cb: function() {
                        me.$toast('删除标签成功');
                        me.updateEditPageLabel();
                    }
                })
                done();
            }
        },
        updateEditPageLabel() {
            // 处理编辑页面的逻辑
            var curPath = this.$router.history.current.path;
            if(curPath.indexOf('edit') != -1) {
                this.$store.state.edit.editedStatus = true;
            }
        }

    }
}
</script>